<form name="f" (ngSubmit)="submit()" #f="ngForm" novalidate formValidTimerRange>
  <h1 mat-dialog-title>
    {{ 'NotForm.First' | translate }} {{ (data.events ? 'NotForm.Second' : 'NotForm.SecondTwoOp') | translate }}
    {{ data.isUser ? data.name : ('NotForm.Third' | translate) }}
  </h1>
  <mat-dialog-content>
    <div>
      <div *ngIf="data.isKaironEnabled && topicsList.kairon.length > 0 && data.isUser">
        <h4 class="subtitle">{{ 'NotForm.NotificationIA' | translate }} {{ 'NotForm.KaironNotifications' | translate }}</h4>

        <ng-container *ngFor="let topic of topicsList.kairon">
          <div fxLayout="row" fxLayoutGap="30px">
            <div fxFlex>
              <mat-checkbox
                color="primary"
                class="user-check"
                [(ngModel)]="topic.selected"
                type="checkbox"
                [ngModelOptions]="{ standalone: true }"
                title="topic.text"
              >
                {{ topic.text | translate }}
              </mat-checkbox>
            </div>
          </div>
        </ng-container>
      </div>

      <div *ngIf="data.isMaiaEnabled && topicsList.maia.length > 0 && data.isUser">
        <h4 class="subtitle">{{ 'NotForm.NotificationIA' | translate }} {{ 'NotForm.MaiaNotifications' | translate }}</h4>

        <ng-container *ngFor="let topic of topicsList.maia">
          <div fxLayout="row" fxLayoutGap="30px">
            <div fxFlex>
              <mat-checkbox
                color="primary"
                class="user-check"
                [(ngModel)]="topic.selected"
                type="checkbox"
                [ngModelOptions]="{ standalone: true }"
                title="topic.text"
              >
                {{ topic.text | translate }}
              </mat-checkbox>
            </div>
          </div>
        </ng-container>
      </div>

      <h4 class="subtitle">{{ 'NotForm.PanelEvents' | translate }}</h4>
      <ng-container *ngFor="let topic of topicsList.notifications">
        <div fxLayout="row" fxLayoutGap="30px">
          <div fxFlex>
            <mat-checkbox
              color="primary"
              class="user-check"
              [(ngModel)]="topic.selected"
              type="checkbox"
              [ngModelOptions]="{ standalone: true }"
              title="topic.text"
            >
              {{ topic.text | translate }}
            </mat-checkbox>
          </div>
        </div>
      </ng-container>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary">{{ 'Shared.Accept' | translate }}</button>
    <button type="button" mat-raised-button (click)="onCancelClick()">{{ 'Shared.Cancel' | translate }}</button>
  </mat-dialog-actions>
</form>
